"use client";

import dynamic from "next/dynamic";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import type { LpHeroAnimationCopy } from "@/data/lpCopy";

const HeroAnimationPlayer = dynamic(
  () => import("@/components/top/HeroAnimationPlayer"),
  {
    ssr: false,
    loading: () => (
      <div className="w-full aspect-[16/10] bg-surface-container-low rounded-2xl animate-pulse" />
    ),
  },
);

interface Props {
  copy: LpHeroAnimationCopy;
}

export default function HeroMedia({ copy }: Props) {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (isDesktop) {
    return (
      <div className="rounded-xl lg:ml-auto lg:mr-0 max-w-2xl overflow-hidden shadow-[0_8px_32px_rgba(44,26,30,0.15)]">
        <HeroAnimationPlayer variant="desktop" controls={false} copy={copy} />
      </div>
    );
  }

  return (
    <div className="max-w-[280px] mx-auto px-6">
      <HeroAnimationPlayer variant="mobile" controls={false} copy={copy} />
    </div>
  );
}
